import React from 'react';

import SourceBoxTitle from './SourceBoxTitle';
import SourceBoxDescription from './SourceBoxDescription';
import SourceBoxSectionList from './SourceBoxSectionList';

class SourceBox extends React.Component {
  render() {
    return(
      <div className={ `country-profile-sourcebox ${this.props.className}` }>
        <div className="container-fluid">
          <SourceBoxTitle
            title={ this.props.title }
            info={ this.props.info }
            logoClass={ this.props.logoClass }
          />
          <SourceBoxDescription content={ this.props.description } />
          <SourceBoxSectionList
            sections={ this.props.sections }
            legend={ this.props.legend }
            hideLargeDescriptions={ this.props.hideLargeDescriptions }
          />
        </div>
      </div>
    );
  }
}

export default SourceBox



// WEBPACK FOOTER //
// ./src/components/SourceBox/SourceBox.js